import { PayloadAction } from '@reduxjs/toolkit';
import { changeHistory, historyPush, setHistoryReplace } from 'reactApp/modules/router/router.module';
import { IHistoryPush } from 'reactApp/modules/router/router.types';
import { put, takeEvery } from 'redux-saga/effects';

function* historyPushSaga(action: PayloadAction<IHistoryPush>) {
    const { id, search = '', hash = '', replace = false } = action.payload;

    yield put(setHistoryReplace(replace));
    yield put(changeHistory(id + search + (hash && `#${hash}`)));
}

export function* watchRouterRoot() {
    yield takeEvery(historyPush.toString(), historyPushSaga);
}
